import React from 'react';
import { CapacidadesProvider } from './CapacidadesContext';
import CapacidadesView from './CapacidadesView';

export default function Capacidades() {
    return (
        <CapacidadesProvider>
            <CapacidadesView />
        </CapacidadesProvider>
    );
}
